var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { LoadingAFY, position, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { usePlan } from "./hook/plan.hook";
import { PlanView } from "./view/plan.view";
export var PlanAdmin = function () {
    var plan = usePlan();
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: plan.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: plan.loadingText, textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), plan.seeToast.show &&
                showToast(position.topRight, plan.seeToast.type, plan.seeToast.message, plan.closeToast), _jsx(PlanView, __assign({}, plan.view))] }));
};
export default PlanAdmin;
